import { isNil } from 'lodash-es';
import qs from 'query-string';

import useQueryHandleWithUserId from './urlQueryString/useQueryHandleWithUserId';

export default function useQueryOptionWithUserId<T = Record<string, unknown>>(
  apiEndpoint: string,
  queryStringObject?: T,
  snakeCase = false,
  fallbackKey?: string,
) {
  const { getCurrentUserId, USER_ID_KEY } = useQueryHandleWithUserId({ fallbackKey });

  const userId = getCurrentUserId();

  const queryString = qs.stringify({ ...queryStringObject });

  if (isNil(userId)) {
    return {
      queryKey: [apiEndpoint, queryStringObject],
      url: [apiEndpoint, queryString].filter(Boolean).join('?'),
    };
  }

  return {
    queryKey: [apiEndpoint, { userId, ...queryStringObject }],
    url: [`${apiEndpoint}?${snakeCase ? 'user_id' : USER_ID_KEY}=${userId}`, queryString]
      .filter(Boolean)
      .join('&'),
  };
}
